export default __webpack_public_path__ + "static/media/calendarHovered.2926ccfb.svg";